export default __webpack_public_path__ + "static/2036397fb947ea970270e710fdac0c10.jpg";